import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import $ from 'jquery'
import axios from 'axios'
import ElementUI from 'element-ui'
import Vant from 'vant'
import 'vant/lib/index.css'
import api from './api/index.js'
import QRCODE from 'qrcodejs2'
/** 富文本编辑器 */
import VueUeditorWrap from 'vue-ueditor-wrap'
import axiosPackag from './js/axiosPackag.js'
import dictionary from './js/dictionary.js'
import preventReClick from './js/preventReClick' //防多次点击，重复提交
import 'element-ui/lib/theme-chalk/index.css'
import './../static/base_system/main.css'
/** 三方矢量图组件 */
import './../static/icon/iconfont.css'
import './../static/css/base.css'
/** ueditor */
import '../static/UEditor/ueditor.config.js'
import '../static/UEditor/ueditor.all.js'
import '../static/UEditor/lang/zh-cn/zh-cn.js'
import '../static/UEditor/ueditor.parse.min.js'

import router from './routes'
import 'font-awesome/css/font-awesome.min.css'
/** 弹窗拖拽 */
import './js/directives.js'
import util from './js/util.js'
/** session 存储 */
import sessionStore from './js/sessionStore.js'
import './../static/fonts/font.css'
/** 控制按钮权限 */
/**学员端页面 */
import '../static/css/myclass.css'
import '../static/css/list.css'
import '../static/css/studentHeader.css'
import '../static/css/studentMain.css'
import '../static/css/studentClasses.css'
import '../static/css/personalmain.css'
import '../static/css/mobileDetail.css'
// 学员端首页 课程中心  头部样式
import '../static/css/update/header.css'
import '../static/css/update/index.css'
import '../static/css/update/vueLogin.css'
import '../static/css/update/courseCener.css'
/** H5 */
import '../static/js/flexible.js'
import '../static/css/flexible.css'
import '../static/css/mobile.css'
import '../static/css/mobileRegister.css'
/** H5 设置cookie */
import Cookies from 'js-cookie'

// 新增移动端查询
// 引入 Vconsole
import Vconsole from 'vconsole'
// 在特定环境才使用
// new Vconsole 
process.env.API_URL === 'restful/' ? new Vconsole : ''

//获取cookie
import { delCookie, getCookie, setCookie } from './js/cookieUtil'

/**vant验证方式**/
// import './common/validator.js'
Vue.use(Vant)

Vue.config.productionTip = false
Vue.prototype.$axiosPackag = axiosPackag
Vue.prototype.$api = api
Vue.prototype.$http = axios
Vue.prototype.$util = util
Vue.prototype.$sessionStore = sessionStore
Vue.prototype.$dictionary = dictionary
Vue.prototype.$sessionStore = sessionStore
Vue.prototype.$preventReClick = preventReClick
Vue.prototype.$qrcode = QRCODE
Vue.use(ElementUI, {
	size: 'small',
})
/** 全局引用富文本 */
Vue.component('vue-ueditor-wrap', VueUeditorWrap)
Vue.prototype.$cookieStore = { setCookie, getCookie, delCookie }

Vue.prototype.getCookie = function (cname) {
	var name = cname + '='
	var ca = document.cookie.split(';')
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i]
		while (c.charAt(0) == ' ') c = c.substring(1)
		if (c.indexOf(name) != -1) return c.substring(name.length, c.length)
	}
	return ''
}
/**
 * 路由的拦截
 */

/*console.info(router.options.routes);
for(let i=0;i<router.options.routes.length;i++){
    debugger
    router.options.routes[i].query.url='111111111111111111111111';
}*/
function getPlatformConfigValue(data) {
	if (typeof data.value != 'undefined') {
		return data.value
	} else {
		return data.defaultValue
	}
}

router.beforeEach((to, from, next) => {
    $.ajax({
        //本地
        // url: "/" + 'restful/web/webPlatformConfig/getPlatformAllConfig',
        //测试
        url: "/" + 'web/webPlatformConfig/getPlatformAllConfig',
        type: 'get',
        async: false,
        data: { domain: document.domain },
        timeout: 5000,
        dataType: 'json',
        success: function(data) {
            for (let i = 0; i < data.data.length; i++) {
                if (data.data[i].name == "h5_index_logo") {
                    to.query.indexLogo = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "h5_login_logo") {
                    to.query.loginLogo = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "platform_title") {
                    to.meta.title = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "if_exam_take_photo") {
                    to.query.ifExamTakePhoto = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "if_lose_focus_auto_submit_paper") {
                    to.query.ifLoseFocusAutoSubmitPaper = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "contact_number") {
                    to.query.contactNumber = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "pc_index_logo") {
                    to.query.pcIndexLogo = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "news_menu_category_display") {
                    to.query.newsMenuCategoryDisplay = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "login_replace_qrcode") {
                    to.query.loginReplaceQrcode = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_download_app") {
                    to.query.showDownloadApp = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "service_udesk_url") {
                    to.query.serviceUdeskUrl = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "platform_title") {
                    to.query.platformTitle = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "login_page_logo") {
                    to.query.loginPageLogo = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "help_file_address_student") {
                    to.query.helpFileAddressStudent = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "help_file_address_org") {
                    to.query.helpFileAddressOrg = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "branch_school_php_url") {
                    to.query.branchSchoolPhpUrl = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_download_app") {
                    to.query.showDownloadApp = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "if_show_footer") {
                    to.query.ifShowFooter = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_position_platform") {
                    to.query.showPositionPlatform = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "help_menu_name") {
                    to.query.helpMenuName = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "platform_favicon") {
                    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = getPlatformConfigValue(data.data[i]);;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
                if (data.data[i].name == "show_platform_statistics") {
                    to.query.showPlatformStatistics = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "downloadapp_qrcode") {
                    to.query.downloadappQrcode = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "main_department") {
                    to.query.mainDepartment = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "platform_pay_type") {
                    to.query.platformPayType = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_recommend") {
                    to.query.showRecommend = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "supervision_login_url") {
                    to.query.supervisionLoginUrl = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "information_bg") {
                    to.query.informationBg = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "supervision_login_domain") {
                    to.query.supervisionLoginDomain = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "help_file_address_supervision") {
                    to.query.helpFileAddressSupervision = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "course_center_show_org_search") {
                    to.query.courseCenterShowOrgSearch = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_register") {
                    to.query.showRegister = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "course_center_show_year_search") {
                    to.query.courseCenterShowYearSearch = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_live_item") {
                    to.query.showLiveItem = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "course_center_show_course_type_search") {
                    to.query.courseCenterShowCourseTypeSearch = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_zhihu_qrcode") {
                    to.query.showZhihuQrcode = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_occupation_search") {
                    to.query.showOccupationSearch = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_org_recommend") {
                    to.query.showOrgRecommend = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "shanxi_building_platform") {
                    to.query.shanxiBuildingPlatform = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "jingang_building_platform") {
                    to.query.jingangBuildingPlatform = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "index_data_statistic_title") {
                    to.query.indexDataStatisticTitle = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_index_contactus") {
                    to.query.showIndexContactus = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_side_bar") {
                    to.query.showSideBar = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "main_department") {
                    to.query.mainDepartment = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "technical_support_department") {
                    to.query.technicalSupportDepartment = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "icp_text") {
                    to.query.icpText = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "if_show_customer_service") {
                    to.query.ifShowCustomerService = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "nmg_supervision_building_platform") {
                    to.query.nmgSupervisionBuildingPlatform = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_header_login") {
                    to.query.showHeaderLogin = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_header_search") {
                    to.query.showHeaderSearch = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_asked_question") {
                    to.query.showAskedQuestion = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "if_show_technical_support_department") {
                    to.query.ifShowTechnicalSupportDepartment = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "index_digital_talents") {
                    to.query.indexDigitalTalents = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_index_banner_category") {
                    to.query.showIndexBannerCategory = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "index_course_ad_dynamics") {
                    to.query.indexCourseAdDynamics = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "show_index_operation_org") {
                    to.query.showIndexOperationOrg = getPlatformConfigValue(data.data[i]);
                }
                if (data.data[i].name == "platformId") {
                    to.query.webPlatformId = getPlatformConfigValue(data.data[i]);
                }
            }
        },
        error: function(xhr, textStatus) {}
    });
    if (to.meta.requireLogin) {
        $.ajax({
            //本地
            // url: '/restful/session/getSession',
            //测试
            url: '/session/getSession',
            type: 'POST',
            async: false,
            data: null,
            timeout: 5000,
            dataType: 'json',
            success: function(data, textStatus, jqXHR) {
                // console.log(data.data);
                /** 当前用户session失效 */
                if (data.status === 600) {
                    if (Cookies.get('mobile') && Cookies.get('password')) { // 判断本地是否存在mobile  password 
                        next(
                            $.ajax({
                                url: '/user/h5login',
                                type: 'POST',
                                async: false,
                                data: { userName: Cookies.get('mobile'), password1: Cookies.get('password') },
                                timeout: 5000,
                                dataType: 'json',
                                success: function(data) {

                                },
                                error: function(xhr, textStatus) {
                                    console.log('路由认证失败了!!' + textStatus);
                                }
                            })
                        )
                    } else {

                        next({ path: "/mobileLogin", query: { redirect: to.fullPath } });
                    }
                } else {
                    /** 更新本地session用户信息 */
                    if (data.data != null) {
                        // console.log("pc已经登录");
                        Vue.prototype.$sessionStore.initSession(data.data);
                    } else {
                        console.log("pc没有登录");
                        next({ path: "/mobileLogin", query: { redirect: to.fullPath } });
                    }
                    /** 需要验证学员身份 */
                    if (to.meta.ifStudent) {
                        var userType = Vue.prototype.$sessionStore.ifStudent;
                        if (userType) {
                            next({ name: '/500', params: { errorMessage: "登录用户与要访问的页面权限不一致！" } });
                        }
                    }
                    /** 需要权限控制的页面 */
                    if (to.meta.requireAuth) {
                        var pArray = to.path.match(/([^\/]+)/g);
                        if (pArray.length > 1) {
                            var p = pArray[1];
                            var menus = Vue.prototype.$sessionStore.getMyMenus();
                            var isExist = false;
                            if (menus != null) {
                                menus.forEach((item) => {
                                    if (item.url == p) {
                                        isExist = true;
                                    }
                                });
                            }
                            if (!isExist) {
                                //next({path: "/login"});
                                next({ name: '/500', params: { errorMessage: "登录用户与要访问的页面权限不一致！" } });
                            }
                        }
                    }
                    next();
                }
            },
            error: function(xhr, textStatus) {
                console.log('路由认证失败了!!' + textStatus);
            }
        });

    } else {
        next();
    }
});
/**
 * 设置每个页面的titel
 */
router.afterEach(function (to, from) {
	if (to.meta.title) {
		document.title = to.meta.title
	}
})

new Vue({
	el: '#app',
	router,
	components: {
		App,
	},
	template: '<App/>',
	data() {
		return {
			cartCount: 0, //初始化购物车数量
		}
	},
})



// WEBPACK FOOTER //
// ./src/main.js